import { call } from 'redux-saga/effects';

import Logger from '../../../tools/Logger';

import * as skipAudioAdHelpers from './helpers';

const log = Logger.child({ component: 'mediator/useCases/skipAudioAd' });

export function* skipAudioAd(action) {
  log.info('skipAudioAd(): starting skip audio ad');

  yield call(skipAudioAdHelpers.handleSkippingAudioAd, action);
}
